import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './FooterSection.scss';
import { company, footerNav, primaryCta, recruitingCta } from '../../../../content/site.js';
import logo from '../../../../assets/images/vrp-logo.png';

const FooterSection = () => {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const year = new Date().getFullYear();

  return (
    <footer className="vh-footer u-grain">
      {/* Pre-footer CTA */}
      <div className="vh-footer__cta">
        <div className="u-container vh-footer__cta-inner">
          <div>
            <span className="u-eyebrow u-eyebrow--on-dark">Let’s talk</span>
            <h2 className="vh-footer__cta-title">
              Practice rehabilitation medicine<br />
              <em>the way it should be practiced.</em>
            </h2>
          </div>
          <div className="vh-footer__cta-actions">
            <Link to={recruitingCta.href} className="btn btn--gold">
              {recruitingCta.label} <span className="btn__arrow" aria-hidden="true">→</span>
            </Link>
            <Link to={primaryCta.href} className="btn btn--ghost-light">
              Talk to us about your unit
            </Link>
          </div>
        </div>
      </div>

      {/* Main */}
      <div className="u-container vh-footer__main">
        <div className="vh-footer__brand">
          <img className="vh-footer__logo-img" src={logo} alt="Virginia Rehab Physicians" />
          <p className="vh-footer__tag">
            A physician-owned PM&amp;R group that medically directs and manages
            inpatient rehabilitation units, and runs them well.
          </p>
          <ul className="vh-footer__contact">
            <li><a href={company.phoneHref}>{company.phone}</a></li>
            <li><a href={`mailto:${company.email}`}>{company.email}</a></li>
          </ul>
        </div>

        <div className="vh-footer__cols">
          {footerNav.map((col) => (
            <nav key={col.heading} className="vh-footer__col" aria-label={col.heading}>
              <h3>{col.heading}</h3>
              <ul>
                {col.links.map((l) => (
                  <li key={l.href}>
                    {l.external ? (
                      <a href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>
                    ) : (
                      <Link to={l.href}>{l.label}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
      </div>

      <div className="u-container vh-footer__bottom">
        <p>&copy; {year} {company.legalName}. All rights reserved.</p>
        <p>Across Virginia</p>
      </div>

      {showTop && (
        <button type="button" className="vh-footer__top" aria-label="Back to top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          ↑
        </button>
      )}
    </footer>
  );
};

export default FooterSection;
